export function getUser(state) {
   return state.user;
}

export function getSpecialCustomerVal(state) {
  return state.special_customer
}